document.addEventListener("DOMContentLoaded", () => {


  // ======================================================
  // VIEWER CONTEXT (SOURCE OF TRUTH)
  // ======================================================
  const interactionRoot = document.getElementById("inveni-interaction-root");

  const viewerContext = {
  userId: interactionRoot?.dataset?.userId || null,
  firstName: interactionRoot?.dataset?.userFname || null,
  lastName: interactionRoot?.dataset?.userLname || null,
  hasAvatar: interactionRoot?.dataset?.userAvatar === "true",
  avatarUrl: interactionRoot?.dataset?.userAvatarUrl || null
};

  const viewerUserId = interactionRoot?.dataset?.userId
    ? String(interactionRoot.dataset.userId)
    : null;
 

  console.log("🎥 Media capture JS loaded");

  let activeRecorder = null;
  let activeStream = null;
  let recordedChunks = [];
  let captureState = "idle"; // idle | recording
  let isReviewOpen = false;

  //Pagination
  let interactionsNextCursor = null;
  let interactionsHasMore = true;
  let interactionsLoading = false;

  // --------------------------------------------
  // Reviews list state (filters + cursor paging)
  // --------------------------------------------
    // --------------------
  // Review filters (minimal)
  // --------------------
  const interactionFilters = {
    rating: null,      // 1..5
    hasImage: false,
    hasVideo: false,
    hasAudio: false,
    verifiedOnly: false   // ✅ NEW
  };




  /**************************************************************
   * ROOT + CONFIG
   **************************************************************/
  const root = document.getElementById("inveni-interaction-root");
    if (!root) {
      console.error("inveni-interaction-root not found");
      return;
    }

    const externalKey = root.dataset.productId;
    const customerId  = root.dataset.userId || "";

    const REACTION_CODES = {
    like: "like",
    love: "love",  
    helpful: "hepful",
    insightful: "insightful",
    funny: "funny",
    downvote: "downvote"
  
  };

  if (!externalKey) {
    alert("Product identifier missing. Reviews disabled.");
    return;
  }
  /* ===============================
 * API BASE CONFIG
 * =============================== */

  const USE_CLOUDFRONT = false;        // 🔁 toggle here
  const USE_SHOP_PROXY = true;       // only one should be true

  const SHOP_URL = "https://ivqev3-ej.myshopify.com";

  const LAMBDA_URL =
    "https://3tgozjynxm6rixfwudwuggrak40adsmp.lambda-url.us-east-2.on.aws";

  const CLOUDFRONT_URL =
    "https://d1kke516u91jxp.cloudfront.net";

  const SHOP_PROXY_BASE =
    `${SHOP_URL}/apps/interactions`;

  const API_BASE = (() => {
    if (USE_CLOUDFRONT) return CLOUDFRONT_URL;
    if (USE_SHOP_PROXY) return SHOP_PROXY_BASE;
    return LAMBDA_URL;
  })();
   

  const DEFAULT_HEADERS = {
    "Content-Type": "application/json",
    "x-shopify-customer-id": customerId,
    "x-inveni-guest-id": getGuestId(),
  };

  function getGuestId() {
    let id = localStorage.getItem("inveni_guest_id");
    if (!id) {
      id = "guest:" + crypto.randomUUID();
      localStorage.setItem("inveni_guest_id", id);
    }
    return id;
}

  

  function renderReviewerIdentity(review) {
  const isOwner = review.isOwner === true;

  let displayName = review.customerId || "Guest";
  let avatarHtml = `
    <span class="interaction-avatar interaction-avatar--default">👤</span>
  `;

  if (isOwner && viewerContext.firstName) {
    displayName =
      viewerContext.firstName +
      (viewerContext.lastName ? " " + viewerContext.lastName : "");

    if (viewerContext.avatarUrl) {
      avatarHtml = `
        <img
          class="interaction-avatar"
          src="${viewerContext.avatarUrl}"
          alt="${displayName}"
          loading="lazy"
        />
      `;
    }
  }

  return `
    <div class="interaction-user-block">
      ${avatarHtml}
      <span class="interaction-user-name">${displayName}</span>
    </div>
  `;
}

function openReviewLoginModal() {
  const modal = document.getElementById("inveni-review-login-modal");
  modal.setAttribute("aria-hidden", "false");
  document.body.classList.add("inveni-modal-open");
}

function closeReviewLoginModal() {
  const modal = document.getElementById("inveni-review-login-modal");
  modal.setAttribute("aria-hidden", "true");
  document.body.classList.remove("inveni-modal-open");
}


 /***************************************
  * Hook the Modal
  ***************************************/
 // Hook into your existing root dataset
//const root = document.getElementById("inveni-interaction-root");
const isLoggedIn = !!(root && root.dataset.userId);

function openReviewLoginModal() {
  const modal = document.getElementById("inveni-review-login-modal");
  if (!modal) return;
  modal.classList.add("is-open");
  modal.setAttribute("aria-hidden", "false");
}

function closeReviewLoginModal() {
  const modal = document.getElementById("inveni-review-login-modal");
  if (!modal) return;
  modal.classList.remove("is-open");
  modal.setAttribute("aria-hidden", "true");
}

document.addEventListener("click", (e) => {
  if (e.target.closest(".inveni-modal-close") ||
      e.target.classList.contains("inveni-modal-overlay")) {
    closeReviewLoginModal();
  }
});

document.addEventListener("click", (e) => {
  const modal = document.getElementById("inveni-review-login-modal");
  if (!modal) return;

  // close
  if (e.target.closest("[data-close]")) {
    closeAuthModal();
    return;
  }

  // auth button routing
  const btn = e.target.closest("[data-auth]");
  if (!btn) return;

  const kind = btn.dataset.auth;
  const returnTo = window.location.pathname + window.location.search + "#reviews";

  // This keeps it Shopify-native: send to /account/login and let Shopify render providers
  // (Shop / Google / Email / Facebook if enabled in Admin)
  if (["shop","google","email"].includes(kind)) {
    const url = `/account/login?return_to=${encodeURIComponent(returnTo)}`;
    window.location.href = url;
  }
});

// Example: gate your existing "Write a review" action
document.getElementById("inveni-write-interaction-btn")?.addEventListener("click", (e) => {
  if (isLoggedIn) return;          // proceed with your existing openReview()
  e.preventDefault();
  openReviewLoginModal();
});

document.addEventListener("click", (e) => {
  const btn = e.target.closest(".inveni-continue-guest");
  if (!btn) return;

  e.preventDefault();

  const guestId = getOrCreateGuestIdentity();

  window.inveniViewerContext = {
    type: "guest",
    guestId
  };

  // Close modal
  closeReviewLoginModal();

  // Allow review UI
  openReview();
});

function getOrCreateGuestIdentity() {
  const KEY = "inveni_guest_id";
  let guestId = localStorage.getItem(KEY);

  if (!guestId) {
    guestId = crypto.randomUUID();
    localStorage.setItem(KEY, guestId);
  }

  return guestId;
}





  /*************************************
   * LOAD REVIEW SUMMARY
   * LOAD REVIEWS
   **************************************/
    loadInteractionsSummary();
    loadInteractions().then(json => {
      if (json.status !== "success") return;

      renderReviews(json.data); // first page → replace
      interactionsNextCursor = json.pageInfo?.nextCursor ?? null;
      interactionsHasMore = json.pageInfo?.hasMore ?? false;
      interactionsFirstLoad = false;
      updateLoadMoreButton();
      });

    /* Add the Load More Handler */
    const loadMoreBtn = document.getElementById("inveni-load-more");
    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener("click", () => {
        if (!interactionsHasMore || interactionsLoading) return;

        interactionsLoading = true;
        updateLoadMoreButton(true);

        loadInteractions()
          .then(json => {
            if (json.status !== "success") return;

            appendReviews(json.data);  // ✅ key fix

            interactionsNextCursor = json.pageInfo?.nextCursor ?? null;
            interactionsHasMore = json.pageInfo?.hasMore ?? false;
          })
          .finally(() => {
            interactionsLoading = false;
            updateLoadMoreButton();
          });
      });
  /**************************************************************
   * MEDIA STATE (REVIEW)
   **************************************************************/

  // Track active uploads so we can abort
    const activeUploads = new Map();
    // mediaUid -> AbortController

    const uploadedReviewMedia = []; 
    // [{ mediaUid, mediaType }]

    let pendingMedia = [];

    const MB = 1024 * 1024;

    const MEDIA_LIMITS = {
      total: 5,

      image: {
        max: 5,
        maxSize: 8 * MB,

        minWidth: 600,
        minHeight: 600,

        maxWidth: 8000,     // safety ceiling
        maxHeight: 8000
      },

      video: {
        max: 1,
        maxSize: 150 * MB,
        softDuration: 60,   // warn after 60s
        maxDuration: 120    // block after 120s
      },

      audio: {
        max: 1,
        maxSize: 50 * MB,
        softDuration: 45,   // warn after 45s
        maxDuration: 90     // block after 90s
      }
    };



  console.log("externalKey:", externalKey);

  /*function resetReviewsAndReload() {
    interactionsNextCursor = null;
    document.getElementById("inveni-reviews-list").innerHTML = "";
    loadInteractions();
  }*/
  

   /* =====================================
   * GUEST ID INITIALIZATION (MUST BE FIRST)
   * ===================================== */
  function ensureGuestId() {
    if (!document.cookie.includes("inveni_guest_id=")) {
      const id = "guest:" + crypto.randomUUID();
      document.cookie =
        `inveni_guest_id=${id}; path=/; max-age=31536000; SameSite=None; Secure`;
    }
  }



  ensureGuestId(); // 👈 CALL IT IMMEDIATELY

  /**************************************************************
   * GENERIC API HELPERS
   **************************************************************/
  async function apiGet(path) {
    try {      
      const res = await fetch(`${API_BASE}${path}`, {
        headers: DEFAULT_HEADERS
      });
      return await res.json();
    } catch (err) {
      console.error("GET failed:", err);
      return { status: "error", message: err.message };
    }
  }

  async function apiDelete(path, payload) {
    try {
      const res = await fetch(`${API_BASE}${path}`, {
        method: "DELETE",
        headers: DEFAULT_HEADERS,
        body: payload ? JSON.stringify(payload) : null
      });

      return await res.json();
    } catch (err) {
      console.error("DELETE failed:", err);
      return { status: "error", message: err.message };
    }
  }


  async function apiPost(path, payload) {
    try {
      const res = await fetch(`${API_BASE}${path}`, {
        method: "POST",
        headers: DEFAULT_HEADERS,
        body: JSON.stringify(payload)
      });
      return await res.json();
    } catch (err) {
      console.error("POST failed:", err);
      return { status: "error", message: err.message };
    }
  }

  /**********************************************************
   * Add duration reader helper (once)
   **********************************************************/
  function getMediaDurationSeconds(file) {
    return new Promise((resolve, reject) => {
      const el = document.createElement(
        file.type.startsWith("audio/") ? "audio" : "video"
      );

      el.preload = "metadata";
      el.src = URL.createObjectURL(file);

      el.onloadedmetadata = () => {
        URL.revokeObjectURL(el.src);
        if (Number.isFinite(el.duration)) {
          resolve(el.duration);
        } else {
          reject(new Error("Unable to read media duration"));
        }
      };

      el.onerror = () => {
        URL.revokeObjectURL(el.src);
        reject(new Error("Unable to load media metadata"));
      };
    });
  }

  /******************************************************
   * Add validator (hard cap + optional soft warning)
   ******************************************************/
    async function validateAudioVideoDuration(file, type) {
      const limits = MEDIA_LIMITS[type];
      if (!limits || !limits.maxDuration) return;

      const duration = await getMediaDurationSeconds(file);

      // HARD CAP — block
      if (duration > limits.maxDuration) {
        throw new Error(
          `${type} is too long. Maximum allowed length is ${limits.maxDuration} seconds.`
        );
      }

      // SOFT CAP — warn only (optional, non-blocking)
      if (limits.softDuration && duration > limits.softDuration) {
        const warnEl = document.getElementById("inveni-review-warnings");
        if (warnEl) {
          warnEl.innerHTML = `
            <div class="inveni-warning">
              ⚠️ Your ${type} is ${Math.round(duration)} seconds.
              Shorter ${type}s tend to get more engagement.
            </div>
          `;
        }
      }
    }

  function validateImageDimensions(file) {
    const limits = MEDIA_LIMITS.image;

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        URL.revokeObjectURL(img.src);

        const { width, height } = img;

        // Minimum check (hard)
        if (width < limits.minWidth || height < limits.minHeight) {
          reject(
            new Error(
              `Image must be at least ${limits.minWidth}×${limits.minHeight}px`
            )
          );
          return;
        }

        // Maximum check (hard safety)
        if (width > limits.maxWidth || height > limits.maxHeight) {
          reject(
            new Error(
              `Image is too large (${width}×${height}). Max allowed is ${limits.maxWidth}×${limits.maxHeight}px`
            )
          );
          return;
        }

        resolve();
      };

      img.onerror = () => {
        URL.revokeObjectURL(img.src);
        reject(new Error("Unable to read image dimensions"));
      };
    });
  }


  function updateSubmitState() {
    const submitBtn = document.getElementById("inveni-submit-interaction");
    if (!submitBtn) return;

    const hasPendingUploads =
      uploadedReviewMedia.some(m => !m.uploaded);

    if (hasPendingUploads) {
      submitBtn.disabled = true;
      submitBtn.textContent = "Uploading…";
      submitBtn.classList.add("is-uploading");
    } else {
      submitBtn.disabled = false;
      submitBtn.textContent = "Submit Review";
      submitBtn.classList.remove("is-uploading");
    }
  }

  /*
  * Replace getMediaCounts() to match your limits
  */
  function getMediaCounts() {
    const counts = {
      total: uploadedReviewMedia.length,
      image: 0,
      video: 0,
      audio: 0
    };

    for (const m of uploadedReviewMedia) {
      if (counts[m.mediaType] !== undefined) {
        counts[m.mediaType]++;
      }
    }

    return counts;
  }
  /*
  * Central validation function (important)
  */
  function validateSelectedFile(file) {
    const mimeType = file.type;

    const mediaType =
      mimeType.startsWith("image/") ? "image" :
      mimeType.startsWith("video/") ? "video" :
      mimeType.startsWith("audio/") ? "audio" :
      null;

    if (!mediaType) {
      return { ok: false, error: "Unsupported file type" };
    }

    const counts = getMediaCounts();

    // 🔢 total limit
    if (counts.total >= MEDIA_LIMITS.total) {
      return {
        ok: false,
        error: `You can upload up to ${MEDIA_LIMITS.total} files`
      };
    }

    // 🖼️ per-type limit
    if (counts[mediaType] >= MEDIA_LIMITS[mediaType]) {
      return {
        ok: false,
        error: `You can upload up to ${MEDIA_LIMITS[mediaType]} ${mediaType}(s)`
      };
    }

    // 📦 size limit
    const maxSize = MEDIA_LIMITS.maxSize[mediaType];
    if (file.size > maxSize) {
      return {
        ok: false,
        error: `${mediaType} exceeds max size of ${Math.round(maxSize / (1024 * 1024))}MB`
      };
    }

    return { ok: true, mediaType };
  }

  /*
  * Safe multi-file handler (uses your limits)
  */
  async function handleSelectedMediaFile(file) {
    const validation = validateSelectedFile(file);

    if (!validation.ok) {
      alert(validation.error);
      return;
    }

    await presignAndUploadReviewMedia(file);
  }

  document.addEventListener("click", function (e) {
      const btn = e.target.closest(".interaction-moderation-btn");
      if (!btn) return;

      const action = btn.dataset.action;     // delete | report | ...
      const interactionUid = btn.dataset.id;
      alert(action);
      alert(interactionUid);
      if (!action || !interactionUid) return;

      // ----------------------------------
      // Optional confirmations
      // ----------------------------------
      if (action === "delete") {
        if (!confirm("Delete this item? This action cannot be undone.")) {
          return;
        }
      }

      if (action === "report") {
        if (!confirm("Report this content for moderation?")) {
          return;
        }
      }

      // ----------------------------------
      // Disable button
      // ----------------------------------
      btn.disabled = true;
      btn.classList.add("is-loading");

      // ----------------------------------
      // Perform moderation request
      // ----------------------------------
      apiPost("/moderate", {
        interactionUid: interactionUid,
        action: action
      })
        .then(function (res) {

          if (!res || res.status !== "success") {
            alert(res && res.message ? res.message : "Action failed");
            btn.disabled = false;
            btn.classList.remove("is-loading");
            return;
          }

          // ----------------------------------
          // Success UI handling
          // ----------------------------------
          if (action === "delete") {
            const card = btn.closest(".interaction-card");
            if (card) {
              card.remove();
            }
          }

          if (action === "report") {
            btn.textContent = "Reported";
            btn.disabled = true;
            btn.classList.add("reported");
          }

        })
        .catch(function (err) {
          console.error("Moderation failed", err);
          alert("Failed to perform action");

          btn.disabled = false;
          btn.classList.remove("is-loading");
        });
    });


    // ---------------------------------------------
    // SHARE EVENT HANDLER (EXTENSIBLE, CLEAN)
    // ---------------------------------------------
    const ICONS = {
    facebook: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#1877F2"
        d="M22 12a10 10 0 1 0-11.56 9.87v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.88 3.77-3.88
        1.09 0 2.23.2 2.23.2v2.45h-1.25c-1.23 0-1.61.76-1.61 1.54V12h2.74l-.44
        2.88h-2.3v6.99A10 10 0 0 0 22 12z"/>
    </svg>`,
        linkedin: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#0A66C2"
        d="M4.98 3.5A2.5 2.5 0 1 1 5 8.5a2.5 2.5 0 0 1-.02-5zM3
        9h4v12H3V9zm7 0h3.8v1.64h.05
        c.53-1 1.83-2.06 3.77-2.06
        C21 8.58 22 10.7 22 13.46V21h-4
        v-6.58c0-1.57-.03-3.6-2.2-3.6
        -2.2 0-2.53 1.72-2.53 3.49V21h-4V9z"/>
    </svg>`,
        x: `
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#000000"
        d="M18.9 2H22l-6.8 7.8L23 22h-6.6l-5.2-6.7L5.3
        22H2l7.3-8.4L1 2h6.8l4.7
        6.1L18.9 2z"/>
    </svg>`,
        whatsapp: `<svg viewBox="0 0 24 24" aria-hidden="true">
          <path fill="#25D366"
            d="M20 12a8 8 0 0 1-12.2 6.9L4 20l1.2-3.6A8 8 0 1 1 20 12zm-4.6 2.2
            c-.2-.1-1.2-.6-1.4-.7-.2-.1-.3-.1-.5.1l-.6.7c-.1.1-.2.2-.4.1
            a6.5 6.5 0 0 1-1.9-1.2 7.2 7.2 0 0 1-1.3-1.6c-.1-.2 0-.3.1-.4
            l.5-.6c.1-.1.1-.3.1-.4l-.5-1.2c-.1-.3-.3-.2-.5-.2h-.4
            c-.1 0-.4.1-.6.3-.2.2-.8.8-.8 1.9s.8 2.2.9 2.4
            c.1.2 1.6 2.6 4 3.6.6.3 1.1.4 1.5.5.6.2
            1.2.2 1.6.1.5-.1 1.2-.5 1.3-.9.2-.4
            .2-.8.1-.9-.1-.1-.2-.1-.4-.2z"/>
            </svg>`,
        email: `
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path fill="#6B7280"
            d="M20 4H4a2 2 0 0 0-2
            2v12a2 2 0 0 0 2
            2h16a2 2 0 0 0
            2-2V6a2 2 0 0 0
            -2-2zm0 4-8
            5-8-5V6l8
            5 8-5v2z"/>
        </svg>`,
        copy: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16 1H6a2 2 0 0 0-2 2v12h2V3h10V1zm3 4H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 16H10V7h9v14z"/></svg>`,
        more: `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7a2 2 0 1 0 .001-3.999A2 2 0 0 0 12 7zm0 7a2 2 0 1 0 .001-3.999A2 2 0 0 0 12 14zm0 7a2 2 0 1 0 .001-3.999A2 2 0 0 0 12 21z"/></svg>`
      };
    // Add an SMS icon (simple pencil / compose)
  ICONS.sms = `<svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M4 20h4l10.5-10.5a2.1 2.1 0 0 0 0-3L16.5 4.5a2.1 2.1 0 0 0-3 0L3 15v5zm2-2v-2.2l8.9-8.9 2.2 2.2L8.2 18H6z"/>
  </svg>`;
  const SHARE_CHANNELS = [
    { key: "native",   label: "More options", icon: ICONS.more,     show: () => !!navigator.share },
    { key: "facebook", label: "Facebook",     icon: ICONS.facebook },
    { key: "x",        label: "X (Twitter)",  icon: ICONS.x },
    { key: "whatsapp", label: "WhatsApp",     icon: ICONS.whatsapp },
    { key: "linkedin", label: "LinkedIn",     icon: ICONS.linkedin },
    { key: "email",    label: "Email",        icon: ICONS.email },
    { key: "sms",      label: "Text",         icon: ICONS.sms },     // add below
    { key: "copy",     label: "Copy link",    icon: ICONS.copy }
  ];




 document.addEventListener("click", function (e) {
  const openBtn = e.target.closest('[data-action="open-share"]');
  if (openBtn) {
    const interactionUid = openBtn.dataset.interactionUid;
  
    if (!interactionUid) return;

    const payload = buildSharePayload(interactionUid, openBtn);
   
    openShareModal(payload);
    return;
  }

  const closeBtn = e.target.closest('[data-action="close-share"]');
  if (closeBtn) {
    closeShareModal();
    return;
  }

  const tile = e.target.closest("[data-share-tile]");
  if (tile) {
    const channel = tile.dataset.shareTile;
    const payload = window.__inveniSharePayload;
    if (!payload) return;
    handleShare(channel, payload);
    return;
  }

  const copyFooter = e.target.closest('[data-action="copy-share"]');
  if (copyFooter) {
    const payload = window.__inveniSharePayload;
    if (!payload) return;
    handleShare("copy", payload);
    return;
  }
});

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeShareModal();
  });

  function openShareModal(payload) {
    window.__inveniSharePayload = payload;

    const modal = document.getElementById("inveni-share-modal");
    const grid = modal.querySelector(".inveni-modal__grid");

    const subtitle = modal.querySelector("#inveni-share-subtitle");
    const productLine = modal.querySelector("#inveni-share-product");
    const coverImg = modal.querySelector("#inveni-share-cover");

    // product title
    productLine.textContent = payload.title || "";

    // subtitle (review excerpt)
    subtitle.textContent = payload.text ? payload.text.slice(0, 80) : "";

    // cover image
    if (payload.cover) {
      coverImg.src = payload.cover;
      coverImg.alt = payload.title ? `${payload.title} cover` : "Book cover";
      coverImg.style.display = "";
    } else {
      coverImg.removeAttribute("src");
      coverImg.alt = "";
      coverImg.style.display = "none";
    }

    // build tiles...
    grid.innerHTML = "";
    SHARE_CHANNELS.forEach(c => { 
      // Build tiles...
      grid.innerHTML = "";

      SHARE_CHANNELS
        .filter(c => !c.show || c.show())
        .forEach(c => {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "inveni-share-tile";
          btn.setAttribute("data-share-tile", c.key);
          btn.setAttribute("aria-label", `Share via ${c.label}`);

          // SVG icons preferred (monochrome path; CSS colors it per brand)
          btn.innerHTML = `
            <span class="inveni-share-tile__icon" aria-hidden="true">${c.icon || ""}</span>
            <span class="inveni-share-tile__label">${c.label}</span>
          `;

          grid.appendChild(btn);
        });


     });

      modal.hidden = false;                 // remove [hidden] state
      modal.classList.add("is-open");       // turn on display
      modal.setAttribute("aria-hidden", "false");

      document.documentElement.classList.add("inveni-modal-open");
      document.body.classList.add("inveni-modal-open");
  }

  



  document.addEventListener("click", (e) => {
    const tile = e.target.closest("[data-action^='share:']");
    if (!tile) return;

    const channel = tile.getAttribute("data-action").split(":")[1];
    const payload = window.__inveniSharePayload;
    if (!payload) return;

    // IMPORTANT: call share immediately (same click event)
    handleShare(channel, payload);

    // close after
    closeShareModal();
  });

  function closeShareModal() {
    const modal = document.getElementById("inveni-share-modal");
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    window.__inveniSharePayload = null;
  }


  function buildSharePayload(interactionUid, triggerEl) {
    const card = triggerEl.closest(".interaction-card");

    const origin = window.location.origin;
    const productPath = window.location.pathname; // PDP path
    const productTitle =
      document.querySelector("h1")?.textContent?.trim() || document.title || "Inveni";

    const cover =
      document.querySelector('meta[property="og:image"]')?.content ||
      document.querySelector('.product__media img')?.src ||
      "";

    // ✅ This is the ONLY url you should give to Facebook
    const shareUrl = `${origin}/apps/interactions/reviews/${encodeURIComponent(interactionUid)}`;

    // ✅ This is useful for copy-link or internal behavior
    const landingUrl = `${origin}${productPath}?review=${encodeURIComponent(interactionUid)}`;

    const reviewText =
      card?.querySelector(".interaction-text")?.textContent?.trim() || "";

    const ratingText =
      card?.querySelector(".interaction-rating")?.textContent?.trim() || "";

    const excerpt =
      reviewText.length > 180 ? reviewText.slice(0, 177) + "…" : reviewText;

    return {
      interactionUid,
      shareUrl,     // use this for Facebook
      landingUrl,   // use this for copy-link if you want
      title: document.title || "Inveni review",
      text: `${ratingText ? ratingText + " " : ""}${excerpt}`
    };
  }


function handleShare(channel, payload) {
  const shareUrl = payload.shareUrl || payload.url; // you can set shareUrl later if you switch to /apps/interactions/reviews/<uid>

  switch (channel) {
    case "native":
      navigator.share({
        title: payload.title || "Inveni review",
        text: payload.text || "",
        url: shareUrl
      }).catch(() => {});
      break;

    case "facebook":
      window.open(
        "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(shareUrl),
        "_blank",
        "noopener,noreferrer,width=600,height=600"
      );
      break;

    case "x":
      window.open(
        "https://twitter.com/intent/tweet?url=" + encodeURIComponent(shareUrl) +
          "&text=" + encodeURIComponent(payload.text || ""),
        "_blank",
        "noopener,noreferrer,width=600,height=600"
      );
      break;

    case "linkedin":
      window.open(
        "https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(shareUrl),
        "_blank",
        "noopener,noreferrer,width=600,height=600"
      );
      break;

    case "whatsapp":
      window.open(
        "https://api.whatsapp.com/send?text=" + encodeURIComponent((payload.text ? payload.text + " " : "") + shareUrl),
        "_blank",
        "noopener,noreferrer,width=600,height=600"
      );
      break;

    case "email":
      window.location.href =
        "mailto:?subject=" + encodeURIComponent(payload.title || "Inveni review") +
        "&body=" + encodeURIComponent((payload.text ? payload.text + "\n\n" : "") + shareUrl);
      break;

    case "sms":
      window.location.href =
        "sms:?&body=" + encodeURIComponent((payload.text ? payload.text + " " : "") + shareUrl);
      break;

    case "copy":
      copyToClipboard(shareUrl);
      break;

    default:
      console.warn("Unknown share channel:", channel);
  }

  closeShareModal();
}

function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    navigator.clipboard.writeText(text).then(() => toast("Link copied!")).catch(() => prompt("Copy link:", text));
  } else {
    prompt("Copy link:", text);
  }
}

function toast(msg) {
  // If you already have a toast system, call it here.
  alert(msg);
}






  /******************************************
   * Toggle Write a Review button
   ******************************************/
  document
  .getElementById("inveni-write-interaction-btn")
  .addEventListener("click", toggleReviewForm);

  function toggleReviewForm() {
    if (isReviewOpen) {
      cancelReview();
    } else {
      openReview();
    }
  }
  function openReview() {
    const box = document.getElementById("inveni-write-interaction-container");
    box.style.display = "block";

    initRatingStars();

    const btn = document.getElementById("inveni-write-interaction-btn");
    btn.textContent = "Cancel Review";
    btn.classList.add("cancel");

    isReviewOpen = true;
  }
  function cancelReview() {
    // Abort uploads
    activeUploads.forEach(ctrl => ctrl.abort());
    activeUploads.clear();

    // Clear local media
    uploadedReviewMedia.length = 0;

    // Reset form
    resetAndCloseReviewForm();
    updateSubmitState(); // ensures clean slate

    const btn = document.getElementById("inveni-write-interaction-btn");
    btn.textContent = "Write a Review";
    btn.classList.remove("cancel");

    isReviewOpen = false;
  }


  /**************************************************************
   * REVIEW MEDIA INPUT HANDLER
   **************************************************************/
  const reviewMediaInput = document.getElementById("inveni-review-media-input");
  const reviewMediaPreview = document.getElementById("inveni-review-media-preview");
  const mediaCounterEl = document.getElementById("inveni-media-counter");
  console.log("MEDIA INPUT CHANGE HANDLER FIRED");

  if (reviewMediaInput) {
    reviewMediaInput.addEventListener("change", async (e) => {
      const files = Array.from(e.target.files);     

    for (const file of files) {
      const error = canAddFile(file, uploadedReviewMedia);
      if (error) { alert(error); break; }

      try {
        const type =
          file.type.startsWith("image/") ? "image" :
          file.type.startsWith("video/") ? "video" :
          file.type.startsWith("audio/") ? "audio" : null;

        if (type === "image") {
          await validateImageDimensions(file);
        }

        // 👉 ADD THIS BLOCK
        if (type === "video" || type === "audio") {
          await validateAudioVideoDuration(file, type);
        }

        await presignAndUploadReviewMedia(file);

      } catch (err) {
        console.error("Media upload failed:", err);
        alert((err && err.message) ? err.message : ("Failed to upload media: " + file.name));
        break;
      }
    }



      // 🔑 IMPORTANT: reset input so same file can be selected again
      //xx e.target.value = "";
      // 🔁 reset input so same file can be selected again
      reviewMediaInput.value = "";
    });
  }


  /**************************************************************
   * LOAD REVIEWS
   **************************************************************/
  function loadInteractions() {
    let url = `/list?externalKey=${encodeURIComponent(externalKey)}`;

    // ✅ ADD FILTER PARAMS (NO BEHAVIOR CHANGE IF NULL)
    if (interactionFilters.rating != null) {
      url += `&rating=${interactionFilters.rating}`;
    }
    if (interactionFilters.hasImage) url += `&hasImage=true`;
    if (interactionFilters.hasVideo) url += `&hasVideo=true`;
    if (interactionFilters.hasAudio) url += `&hasAudio=true`;
    if (interactionFilters.verifiedOnly) {  url += `&isVerifiedPurchase=true`; }

    if (interactionsNextCursor) {
      url += `&cursor=${encodeURIComponent(interactionsNextCursor)}`;
    }

      // 🔎 DEBUG — log final URL
    console.log("🚀 loadInteractions URL:", url);
    //xx alert("url =" + url);
    return apiGet(url);     
  }

  function applyFiltersAndReload() {
    interactionsNextCursor = null;
    interactionsHasMore = false;

    // 🔑 HIDE immediately during reload
    const loadMoreBtn = document.getElementById("inveni-load-more");
    if (loadMoreBtn) loadMoreBtn.style.display = "none";

    // ✅ clear the correct container
    const thread = document.getElementById("inveni-interaction-thread");
    if (thread) thread.innerHTML = "";

    // ✅ fetch + render page 1 with filters
    loadInteractions().then(json => {
      if (json.status !== "success") return;

      renderReviews(json.data);
      interactionsNextCursor = json.pageInfo?.nextCursor ?? null;
      interactionsHasMore = json.pageInfo?.hasMore ?? false;

      updateLoadMoreButton();
      renderFilterChips();
      syncFilterActiveStates();
    });
  }


  function renderFilterChips() {
    const el = document.getElementById("review-filter-chips");
    if (!el) return;

    const chips = [];

    if (interactionFilters.rating != null) {
      chips.push({
        key: "rating",
        label: `${interactionFilters.rating}★`,
        clear: () => interactionFilters.rating = null
      });
    }

    if (interactionFilters.hasImage) {
      chips.push({
        key: "hasImage",
        label: "📷 Photos",
        clear: () => interactionFilters.hasImage = false
      });
    }

    if (interactionFilters.hasVideo) {
      chips.push({
        key: "hasVideo",
        label: "🎥 Videos",
        clear: () => interactionFilters.hasVideo = false
      });
    }

    if (interactionFilters.hasAudio) {
      chips.push({
        key: "hasAudio",
        label: "🎧 Audio",
        clear: () => interactionFilters.hasAudio = false
      });
    }
    if (interactionFilters.verifiedOnly) {
      chips.push({
        key: "verifiedOnly",
        label: "✔ Verified purchase",
        clear: () => interactionFilters.verifiedOnly = false
      });
    }

    // ✅ ADD CLEAR ALL CHIP (only if at least one filter exists)
    if (chips.length > 1) {
      chips.push({
        key: "clearAll",
        label: "Clear all",
        clear: () => {
          interactionFilters.rating = null;
          interactionFilters.hasImage = false;
          interactionFilters.hasVideo = false;
          interactionFilters.hasAudio = false;
          interactionFilters.verifiedOnly = false;

          // sync active UI state
          document
            .querySelectorAll(".filter-media.active, .rating-bar.active")
            .forEach(el => el.classList.remove("active"));
        }
      });
    }

    if (!chips.length) {
      el.innerHTML = "";
      el.style.display = "none";
      return;
    }

    el.style.display = "flex";
    el.innerHTML = chips.map((c, i) => `
      <span class="review-filter-chip ${c.key === "clearAll" ? "filter-chip-clear" : ""}"
            data-index="${i}">
        ${c.label}
        <button class="chip-remove">×</button>
      </span>
    `).join("");

    el.querySelectorAll(".review-filter-chip").forEach((chipEl, i) => {
      chipEl.addEventListener("click", (e) => {
        e.stopPropagation();       // 🛑 avoid bubbling conflicts
        chips[i].clear();          // mutate state
        applyFiltersAndReload();   // single refresh path
      });
    });
  }


  function resetAndReloadInteractions() {
    interactionsNextCursor = null;
    interactionsHasMore = false;

    loadInteractions().then(json => {
      if (json.status !== "success") return;

      renderReviews(json.data);

      interactionsNextCursor = json.pageInfo?.nextCursor ?? null;
      interactionsHasMore = json.pageInfo?.hasMore ?? false;

      updateLoadMoreButton();
    });
  }

  function syncFilterActiveStates() {
    // rating bars
    document.querySelectorAll(".rating-bar").forEach(bar => {
      bar.classList.toggle(
        "active",
        Number(bar.dataset.rating) === interactionFilters.rating
      );
    });

    // media toggles (ONLY elements with data-media)
    document.querySelectorAll(".filter-media[data-media]").forEach(el => {
      const type = el.dataset.media;
      if (!type) return;

      const key = "has" + type.charAt(0).toUpperCase() + type.slice(1);
      el.classList.toggle("active", !!interactionFilters[key]);
    });

    // verified toggle
    const verifiedEl = document.querySelector(".filter-verified");
    if (verifiedEl) {
      verifiedEl.classList.toggle("active", interactionFilters.verifiedOnly);
    }
  }


  

  /**************************************************************
   * RENDER REVIEWS
   **************************************************************/
  function renderReviews(reviews) {
    const container = document.getElementById("inveni-interaction-thread");
    container.innerHTML = "";

    reviews.forEach(review => {
      container.appendChild(renderReviewCard(review)); 
      
    // 🔥 LOAD ALL REPLIES FOR THIS REVIEW
    loadReplies(review.interactionUid);
    });    
  }

  function renderVerifiedBadge(review, reviewEl) {
    if (!review.isVerifiedPurchase) return;

    const badge = document.createElement("span");
    badge.className = "review-badge review-badge--verified";
    badge.textContent = "Verified Purchase";

    const header = reviewEl.querySelector(".review-header");
    if (header) {
      header.appendChild(badge);
    }
  }

  /*************************************************
   * APPEND REVIEWS
   ****************************************************/
  function appendReviews(reviews) {
  const container = document.getElementById("inveni-interaction-thread");

    reviews.forEach(review => {
      container.appendChild(renderReviewCard(review));
      loadReplies(review.interactionUid);
    });
  }

  /*******************************************************
   * Media Helper Function
   ********************************************************/
  function updateMediaCounter() {
    if (!mediaCounterEl) return;
    mediaCounterEl.textContent = `${uploadedReviewMedia.length} / ${MEDIA_LIMITS.total}`;
  }

  /*********************************************************
   * Add a helper function (JS) to hide create review form
   *********************************************************/
  function resetAndCloseReviewForm() {
    // Clear text
    document.getElementById("inveni-interaction-text").value = "";

    // Reset rating
    document.getElementById("rating-value").value = "0";
    document
      .querySelectorAll("#inveni-rating-stars .star")
      .forEach(star => star.classList.remove("selected"));

    //Update Media Counter
    updateMediaCounter();

    // Clear media state
    uploadedReviewMedia.length = 0;

    const preview = document.getElementById("inveni-review-media-preview");
    if (preview) preview.innerHTML = "";

    const fileInput = document.getElementById("inveni-review-media-input");
    if (fileInput) fileInput.value = "";

    // Hide form (collapse)
    const box = document.getElementById("inveni-write-interaction-container");
    if (box) {
      box.style.display = "none";
    }
  }

  /**************************************************************
 * RENDER REVIEW SUMMARY
 **************************************************************/
  function renderReviewSummary(data) {
    const el = document.getElementById("inveni-review-summary");
    if (!el) return;

    const reviewCount = data.reviewCount ?? 0;
    const averageRating = data.averageRating ?? 0;
    const ratingDistribution = data.ratingDistribution ?? {};
    const mediaTotals =
    data.media?.totals ?? data.mediaCounts ?? { image: 0, video: 0, audio: 0 };
    const mediaReviewCounts =
    data.media?.reviews ?? { image: 0, video: 0, audio: 0 };

    const hasReviews = reviewCount > 0;

    const stars = hasReviews
      ? "★★★★★☆☆☆☆☆".slice(
          5 - Math.round(averageRating),
          10 - Math.round(averageRating)
        )
      : "☆☆☆☆☆";

    el.innerHTML = `
      <div class="inveni-review-summary-card">

        <div class="inveni-review-summary-left">
          <div class="inveni-review-summary-rating">
            <span class="rating-stars">${stars}</span>
            <span class="rating-value">
              ${hasReviews ? `${averageRating.toFixed(1)} out of 5` : "No ratings yet"}
            </span>
          </div>

          <div class="review-count">
            ${
              hasReviews
                ? `Based on ${reviewCount} review${reviewCount > 1 ? "s" : ""}`
                : "Be the first to write a review."
            }
          </div>
        

        <div class="review-media-counts">
            <!-- Row 1: media totals (informational) -->
            <div class="media-totals">
              <span class="media-count">📷 ${mediaTotals.image} photos</span>
              <span class="media-count">🎥 ${mediaTotals.video} videos</span>
              <span class="media-count">🎧 ${mediaTotals.audio} audio</span>
            </div>

            ${
              mediaReviewCounts.image ||
              mediaReviewCounts.video ||
              mediaReviewCounts.audio
                ? `
                  <!-- Row 2: reviews with media (actionable) -->
                  <div class="media-review-counts">
                    <span class="filter-media" data-media="image">
                      📷 ${mediaReviewCounts.image} reviews with photos
                    </span>
                    <span class="filter-media" data-media="video">
                      🎥 ${mediaReviewCounts.video} with videos
                    </span>
                    <span class="filter-media" data-media="audio">
                      🎧 ${mediaReviewCounts.audio} with audio
                    </span>
                    <span class="filter-media filter-verified" data-filter="verified">
                      ✅ Verified purchase
                    </span>
                  </div>
                `
                : ""
            }
          </div>
        </div>

        <div class="inveni-review-summary-right">
          ${[5, 4, 3, 2, 1]
            .map(r => {
              const count = ratingDistribution[r] ?? 0;
              const percent = hasReviews && reviewCount > 0
                    ? Math.round((count / reviewCount) * 100)
                    : 0;

              return `
                <div class="rating-bar" data-rating="${r}">
                  <!--<span class="rating-label">${r}★</span>-->
                  <span class="rating-label">
                      ${renderStars(r)}
                    </span>
                  <div class="rating-bar-track">
                    <div class="rating-bar-fill" style="width:${percent}%">.</div>
                  </div>
                  <span class="rating-count">${count}/${reviewCount}</span>
                </div>
              `;
            })
            .join("")}
        </div>

      <div class="review-summary-filters">
        <div id="review-filter-chips" class="review-filter-chips"></div>
      </div>

      </div>
    `;
  }

  function renderStars(rating) {
    return "★★★★★☆☆☆☆☆".slice(5 - rating, 10 - rating);
  }






 /**************************************************************
  * RENDER REVIEW CARD
  **************************************************************/
  function renderReviewCard(review) {
    const interactionUid = review.interactionUid; // ✅ SOURCE OF TRUTH
    // ✅ OWNER CHECK (ADD HERE)
    const isOwner = review.isOwner === true;
    const isVerified = review.isVerifiedPurchase === true;

    const verifiedBadgeHtml = isVerified
      ? `<span class="interaction-badge interaction-badge--verified">
          Verified Purchase
        </span>`
      : "";

    const el = document.createElement("div");
    el.className = "interaction-card";

    const ageLabel = review.createdAt ? timeAgo(review.createdAt) : "";
    const dateLabel = review.createdAt
      ? new Date(review.createdAt).toLocaleDateString(undefined, {
          year: "numeric",
          month: "short",
          day: "numeric"
        })
      : "";
    const likeCount = review.reactionCounts?.like ?? 0;
    const loveCount = review.reactionCounts?.love ?? 0;

    const viewerLikes = review.viewerReactions?.includes("like");
    const viewerLoves = review.viewerReactions?.includes("love");
    //xx alert(review.replyCount);

    const mediaHtml = renderInteractionMedia(review.media);

    el.innerHTML = `
      <div class="interaction-header">
        <span class="interaction-user">
          ${renderReviewerIdentity(review)}
          ${verifiedBadgeHtml}
        </span>
      <span class="interaction-meta">
      ${review.rating ? `<span class="interaction-rating">${"★".repeat(review.rating)}</span>` : ""}      
        ${dateLabel ? `· ${dateLabel}` : ""}
        ${ageLabel ? `(${ageLabel})` : ""}
      </span>
      
        
      </div>

      <div class="interaction-text">${review.body}</div>

      <!-- MEDIA HTML -->
      ${mediaHtml}

      <!-- ACTION ROW -->      
        <div class="interaction-action-row">

          <!-- LEFT: reactions -->
          <div class="interaction-reactions">
          <button
              class="reaction-btn ${viewerLikes ? "reacted" : ""}"
              data-type="like"
              data-id="${interactionUid}"
              data-reactioncode="like"
              aria-label="Like this review"
            >
              <svg class="icon icon-like" viewBox="0 0 24 24">
                  <path fill="currentColor"
                        d="M2 10h4v12H2V10z M22 11.5c0-.8-.3-1.4-.8-1.9-.5-.5-1.1-.8-1.9-.8h-6.2l.9-4.1v-.3c0-.3-.1-.6-.3-.8L13 3 7.6 8.4C7.2 8.8 7 9.3 7 9.9V20c0 1.1.9 2 2 2h7.1c.8 0 1.5-.5 1.8-1.2l3-7.1c.1-.2.1-.5.1-.7z"/>
                </svg>
              

              <span class="reaction-count">${likeCount}</span>
            </button>


            <button class="reaction-btn ${viewerLoves ? "reacted" : ""}"
                    data-type="love"
                    data-id="${interactionUid}"
                    data-reactioncode="love"
                    aria-label="Love this review">

                    <svg class="icon icon-love" viewBox="0 0 24 24">
                      <path fill="currentColor"
                        d="M12 21s-6.7-4.35-9.33-7.28C-1 10.6 1.3 4.5 6.4 4.5c2.1 0 3.6 1.1 4.6 2.5 1-1.4 2.5-2.5 4.6-2.5 5.1 0 7.4 6.1 3.7 9.22C18.7 16.65 12 21 12 21z"/>
                    </svg>
              <span class="reaction-count">${loveCount}</span>
            </button>
          </div>

          <!-- CENTER: reply actions -->
          <div class="interaction-actions">
            <button class="inveni-btn-secondary reply-btn"
                    data-id="${interactionUid}"
                    aria-label="Reply to this review">
                    <svg class="icon icon-reply" viewBox="0 0 24 24">
                      <path fill="currentColor"
                        d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.5 11 4.1-.5-5-3.5-10-11-10z"/>
                    </svg>
                Reply
            </button>

            ${review.replyCount > 0 ? `
              <button class="inveni-btn-secondary toggle-replies-btn"
                      data-id="${interactionUid}"
                      data-count="${review.replyCount}"
                      data-loaded="false"
                      data-visible="false">

                Show replies (${review.replyCount})
              </button>
            ` : ""}
          </div>

          <!-- RIGHT: moderation -->
          <div class="interaction-moderation">
          ${isOwner ? `
              <button
                class="interaction-moderation-btn delete"
                data-action="delete"
                data-id="${interactionUid}"
                'title="Delete"
                aria-label="Delete review">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    d="M9 3h6l1 2h5v2H3V5h5l1-2zm1 6h2v9h-2V9zm4 0h2v9h-2V9zM6 9h2v9H6V9z"
                    fill="currentColor"
                  />
                </svg> Delete
              </button>
            ` : ""}

            ${!isOwner ? `
              <button
                class="interaction-moderation-btn report"
                data-action="report"
                title="Report"
                aria-label="Report review"
                data-id="${interactionUid}">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    d="M5 3v18H3V3h2zm3 0h10l-2 4 2 4H8v10H6V3h2z"
                    fill="currentColor"
                  />
                </svg> Report
              </button>
            ` : ""}

           <button
              type="button"
              class="inveni-btn-secondary share-btn"
              data-action="open-share"
              data-id="${interactionUid}"
              data-interaction-uid="${interactionUid}"
              aria-haspopup="dialog"
              aria-controls="inveni-share-modal"
              aria-label="Share review"
            >
              Share
            </button>
          </div>

        </div><!-- ACTION ROW -->



      <!-- REPLY FORM (HIDDEN) -->
      <div
            class="reply-form-container"
            id="reply-form-${interactionUid}"
            style="display:none;">
            <textarea
              class="reply-input"
              id="reply-text-${interactionUid}"
              placeholder="Write a reply..."
            ></textarea>
            <button
              class="submit-reply-btn"
              data-parent="${interactionUid}">
              Submit Reply
            </button>
          </div>

      <!-- REPLIES (HIDDEN) -->
      <div
        class="interaction-replies"
        id="replies-${interactionUid}"
        style="display:none;">
      </div>

    `;

    return el;
  }

function updateLoadMoreButton(isLoading = false) {
  const btn = document.getElementById("inveni-load-more");
  if (!btn) return;

  if (!interactionsHasMore) {
    btn.style.display = "none";
    return;
  }

  btn.style.display = "inline-block";
  btn.disabled = isLoading;
  btn.textContent = isLoading ? "Loading..." : "Load more reviews";
}

function renderInteractionMedia(mediaList) {
      if (!Array.isArray(mediaList) || mediaList.length === 0) return "";

      const sorted = [...mediaList].sort((a, b) => a.position - b.position);

      const videos = sorted.filter(m => m.mediaType === "video");
      const images = sorted.filter(m => m.mediaType === "image");
      const audios = sorted.filter(m => m.mediaType === "audio");

      let html = `<div class="interaction-media">`;

      [...videos, ...images, ...audios].forEach(m => {

        if (m.mediaType === "video") {
          html += `
           
              <video
                src="${m.url}"
                class="interaction-media-video"
                controls
                preload="metadata"
              ></video>
           
          `;
        }

        if (m.mediaType === "image") {
          html += `
            
              <img
                src="${m.url}"
                class="interaction-media-image"
                loading="lazy"
              />
            
          `;
        }

        if (m.mediaType === "audio") {
          html += `
            
              <audio
                src="${m.url}"
                class="interaction-media-audio"
                controls
              ></audio>
            
          `;
        }
      });

      html += `</div>`;
      return html;
  }

  /**************************************************************
   * STAR RATING
   **************************************************************/
  function initRatingStars() {
    const stars = document.querySelectorAll("#inveni-rating-stars .star");
    const ratingInput = document.getElementById("rating-value");

    stars.forEach(star => {
      star.onclick = () => {
        const val = parseInt(star.dataset.value);
        ratingInput.value = val;
        stars.forEach(s =>
          s.classList.toggle("selected", parseInt(s.dataset.value) <= val)
        );
      };
    });
  }

  /**************************************************************
   * TIME AGO HELPER
   **************************************************************/
  function timeAgo(isoDate) {
    if (!isoDate) return "";

    const seconds = Math.floor((Date.now() - new Date(isoDate)) / 1000);

    if (isNaN(seconds) || seconds < 0) return "";

    if (seconds < 60) return "just now";

    const intervals = [
      { label: "year", seconds: 31536000 },
      { label: "month", seconds: 2592000 },
      { label: "day", seconds: 86400 },
      { label: "hour", seconds: 3600 },
      { label: "minute", seconds: 60 }
    ];

    for (const i of intervals) {
      const count = Math.floor(seconds / i.seconds);
      if (count >= 1) {
        return `${count} ${i.label}${count > 1 ? "s" : ""} ago`;
      }
    }

    return "";
  }


 /**************************************************************
 * SUBMIT REVIEW (FIXED)
 **************************************************************/
  const submitReviewBtn = document.getElementById("inveni-submit-interaction");

  if (submitReviewBtn) {
    submitReviewBtn.addEventListener("click", async () => {
      const body = document.getElementById("inveni-interaction-text").value.trim();
      const rating = parseInt(document.getElementById("rating-value").value, 10);

      if (!body || !rating) {
        alert("Please enter text and rating");
        return;
      }
      // ⛔ Block submit while uploads are in progress
      if (uploadedReviewMedia.some(m => !m.uploaded)) {
        alert("Please wait for all media uploads to finish.");
        return;
      }

      // 🔒 Validate media before submit
      for (const m of uploadedReviewMedia) {
        if (!m.mediaUid || !m.s3Key) {
          console.error("Invalid media object:", m);
          alert("Media upload incomplete. Please retry.");
          return;
        }
      }

      const payload = {
        externalKey,
        rating,
        body,
        handle: `review-${Date.now()}`,
        media: uploadedReviewMedia.map((m, idx) => ({
          mediaUid: m.mediaUid,
          s3Key: m.s3Key,        // ✅ REQUIRED
          mediaType: m.mediaType,
          position: idx          // ✅ REQUIRED
        }))
      };

      console.log("SUBMIT PAYLOAD:", payload);
      //xx alert("Sending review:\n" + JSON.stringify(payload, null, 2));

      try {
        const json = await apiPost("/create", payload);

        //xx alert("Review response:\n" + JSON.stringify(json, null, 2));

        if (json.status === "success") {
            resetAndCloseReviewForm();
            uploadedReviewMedia.length = 0;
            if (reviewMediaPreview) reviewMediaPreview.innerHTML = "";

            //Reload summary data
            loadInteractionsSummary();

            // 🔄 Reset pagination state
            interactionsNextCursor = null;
            interactionsHasMore = false;

            // Reload page 1
            loadInteractions().then(json => {
              if (json.status !== "success") return;

              renderReviews(json.data);

              interactionsNextCursor = json.pageInfo?.nextCursor ?? null;
              interactionsHasMore = json.pageInfo?.hasMore ?? false;

              updateLoadMoreButton();
            });

            cancelReview();
          }

      } catch (err) {
        console.error("Submit failed", err);
        alert("Failed to submit review");
      }
    });
  }


  /**************************************************************
   * 🔥 SINGLE DELEGATED CLICK HANDLER (REPLY + SUBMIT)
   **************************************************************/
  document.addEventListener("click", async (e) => {

    /**********************************
     * Stop Recording
     **********************************/

    if (e.target.closest("#stop-capture-btn")) {
      console.log("⏹ Stop capture clicked, state:", captureState);

      if (captureState === "recording" && activeRecorder?.state === "recording") {
        activeRecorder.stop(); // triggers onstop
      }

      return;
    }

    /* =====================================================
      🎥 RECORD VIDEO (delegated — Shopify safe)
    ===================================================== */
      if (e.target.closest("#capture-video-btn")) {
        const error = canAddFile(file, uploadedReviewMedia);
        if (error) {
          alert(error);
          return;
        }
        //xx alert('1');
        if (captureState === "recording") {
          console.warn("Already recording, ignoring");
          return;
        }

        captureState = "recording";
        //xx alert('2');
        if (!window.isSecureContext) {
          alert("Camera access requires HTTPS");
          return;
        }

        //xx alert('3');
        activeStream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true
        });

        const videoEl = document.getElementById("live-video-preview");
        const audioIndicator = document.getElementById("live-audio-indicator");
        const captureBox = document.getElementById("interaction-capture-preview");

        
        videoEl.srcObject = activeStream;
        videoEl.style.display = "block";
        audioIndicator.style.display = "none";
        captureBox.style.display = "flex";
        
        recordedChunks = [];
        activeRecorder = new MediaRecorder(activeStream);

        activeRecorder.ondataavailable = e => {
          if (e.data.size > 0) recordedChunks.push(e.data);
        };

        activeRecorder.onstop = async () => {
          const blob = new Blob(recordedChunks, {
            type: activeRecorder.mimeType
          });

          const file = new File(
            [blob],
            `review-video-${Date.now()}.webm`,
            { type: activeRecorder.mimeType }
          );

          cleanupCaptureUI();
          await presignAndUploadReviewMedia(file);
        };

        

        activeRecorder.start();
        return;
      }


    /* =====================================================
    🎤 RECORD AUDIO (delegated — Shopify safe)
      ===================================================== */
     if (e.target.closest("#capture-audio-btn")) {
        if (countMedia("audio") >= 1) {
          alert("Only one audio clip is allowed per review.");
          return;
        }
        if (captureState === "recording") {
          console.warn("Already recording, ignoring");
          return;
        }

        captureState = "recording";
        if (!window.isSecureContext) {
          alert("Microphone access requires HTTPS");
          return;
        }

        activeStream = await navigator.mediaDevices.getUserMedia({
          audio: true
        });

        const videoEl = document.getElementById("live-video-preview");
        const audioIndicator = document.getElementById("live-audio-indicator");
        const captureBox = document.getElementById("interaction-capture-preview");

        videoEl.style.display = "none";
        audioIndicator.style.display = "block";
        captureBox.style.display = "flex";

        recordedChunks = [];
        activeRecorder = new MediaRecorder(activeStream);

        activeRecorder.ondataavailable = e => {
          if (e.data.size > 0) recordedChunks.push(e.data);
        };

        activeRecorder.onstop = async () => {
          const blob = new Blob(recordedChunks, {
            type: activeRecorder.mimeType
          });

          const file = new File(
            [blob],
            `review-audio-${Date.now()}.webm`,
            { type: activeRecorder.mimeType }
          );

          cleanupCaptureUI();
          await presignAndUploadReviewMedia(file);

          
        };

        activeRecorder.start();
        return;
      }




   // -----------------------------
    // Toggle replies (SAFE BLOCK)
    // -----------------------------
    const toggleBtn = e.target.closest(".toggle-replies-btn");
    if (toggleBtn) {
      try {
        const parentUid  = toggleBtn.dataset.id;
        const repliesBox = document.getElementById(`replies-${parentUid}`);
        if (!repliesBox) return;

        const isVisible = toggleBtn.dataset.visible === "true";
        const isLoaded  = toggleBtn.dataset.loaded === "true";
        const count     = toggleBtn.dataset.count || "0";

        if (isVisible) {
          repliesBox.style.display = "none";
          toggleBtn.dataset.visible = "false";
          toggleBtn.textContent = `Show replies (${count})`;
          return;
        }

        repliesBox.style.display = "block";
        toggleBtn.dataset.visible = "true";

        if (isLoaded) {
          toggleBtn.textContent = "Hide replies";
          return;
        }

        toggleBtn.textContent = "Loading replies…";

        const json = await apiGet(`/replies?parentInteractionUid=${parentUid}`);

        if (!json || json.status !== "success") {
          toggleBtn.textContent = `Show replies (${count})`;
          console.error("Replies API error:", json);
          return;
        }

        repliesBox.innerHTML = "";
        json.data.forEach(reply => repliesBox.appendChild(renderReplyCard(reply)));

        toggleBtn.dataset.loaded = "true";
        toggleBtn.textContent = "Hide replies";
        return;

      } catch (err) {
        console.error("Toggle replies error:", err);
        // IMPORTANT: do NOT break other clicks
        return;
      }
    }



    // Toggle reply form
    const replyBtn = e.target.closest(".reply-btn");
    if (replyBtn) {
      const parentUid = replyBtn.dataset.id;
      console.log("Reply clicked:", parentUid);
      const formBox = document.getElementById(`reply-form-${parentUid}`);
      //xx const container = document.getElementById(`replies-${parentUid}`);
      if (!formBox) return;

      formBox.style.display =
        formBox.style.display === "none" ? "block" : "none";

      return;
      /*if (!container) return;

        // 🔥 ENSURE CONTAINER IS VISIBLE
      container.style.display = "block";

      const form = container.querySelector(".reply-form");
      if (!form) return;

      form.style.display =
        form.style.display === "none" ? "block" : "none";

      return;*/
    }

    // Submit reply
    const submitBtn = e.target.closest(".submit-reply-btn");
    if (submitBtn) {
      const parentUid = submitBtn.dataset.parent;
      submitReply(parentUid);
    }

    /* --------------------------------
   * REACTION CLICK HANDLER
   * -------------------------------- */
     const reactionBtn = e.target.closest(".reaction-btn");
        if (reactionBtn) {
          const interactionUid = reactionBtn.dataset.id;
          const reactionCode  = reactionBtn.dataset.reactioncode;

          if (!interactionUid || !reactionCode) return;

          const countSpan = reactionBtn.querySelector(".reaction-count");
          if (!countSpan) return;

          // 🔥 STEP 1: OPTIMISTIC UI (instant feedback)
          let current = parseInt(countSpan.textContent, 10) || 0;

          const isActive = reactionBtn.classList.contains("reacted");
          if (isActive) {
            countSpan.textContent = Math.max(0, current - 1);
            reactionBtn.classList.remove("reacted");
          } else {
            countSpan.textContent = current + 1;
            reactionBtn.classList.add("reacted");
          }

          // Optional: prevent rapid double-click spam
          reactionBtn.disabled = true;

          // 🔁 STEP 2: SERVER RECONCILIATION
          apiPost("/react", {
            interactionUid,
            reactionCode
          }).then(json => {
            reactionBtn.disabled = false;

            if (json.status !== "success") {
              // rollback optimistic change on failure
              countSpan.textContent = current;
              reactionBtn.classList.toggle("reacted", isActive);
              alert(json.message || "Failed to react");
              return;
            }

            // ✅ authoritative correction
            const { count, action } = json.data;
            countSpan.textContent = count;

            if (action === "reaction_added") {
              reactionBtn.classList.add("reacted");
            } else {
              reactionBtn.classList.remove("reacted");
            }
          });

    return;
    }


  });

  /*************************************************************
   * Helper to count number of media items
   *************************************************************/
  function countMedia(type) {
    return uploadedReviewMedia.filter(m => m.mediaType === type).length;
  }

  /**************************************************************
   * SUBMIT REPLY
   **************************************************************/
  function submitReply(parentUid) {
    const textarea = document.getElementById(`reply-text-${parentUid}`);
    if (!textarea) {
      alert("Reply textarea not found");
      return;
    }

    const body = textarea.value.trim();

    //xx alert("SubmitReply reached");

    if (!body) {
      alert("Reply cannot be empty");
      return;
    }

    const payload = {
      externalKey,
      parentInteractionUid: parentUid,
      body
    };

    alert("Sending reply:\n" + JSON.stringify(payload, null, 2));

    apiPost("/reply", payload)
      .then(json => {
        alert("Reply response:\n" + JSON.stringify(json, null, 2));
        if (json.status === "success") {
          // 1️⃣ Clear textarea
          textarea.value = "";

          // 2️⃣ Hide reply form (IMPORTANT)
          const formContainer = document.getElementById(`reply-form-${parentUid}`);
          if (formContainer) {
            formContainer.style.display = "none";
          }

          // 3️⃣ Update + flip replies button
            const toggleBtn = document.querySelector(
              `.toggle-replies-btn[data-id="${parentUid}"]`
            );

            if (toggleBtn) {
              let count = parseInt(toggleBtn.dataset.count || "0", 10) + 1;
              toggleBtn.dataset.count = count;
              toggleBtn.dataset.visible = "true";
              toggleBtn.textContent = "Hide replies";
            }

            // 4️⃣ Show replies and refresh only replies
            const repliesBox = document.getElementById(`replies-${parentUid}`);
            if (repliesBox) {
              repliesBox.style.display = "block";
            }

            loadReplies(parentUid);

          //loadReviews();
          // 🔥 THIS IS THE KEY LINE
          //loadReplies(parentUid);
        }
      });
  }

  /**************************************************************
 * LOAD REVIEW SUMMARY
 **************************************************************/
  async function loadInteractionsSummary() {
  const root = document.getElementById("inveni-interaction-root");
  const summaryEl = document.getElementById("inveni-review-summary");
  
  if (!root || !summaryEl) return;
 
  const externalKey = root.dataset.productId;
  //xx alert(externalKey);
  if (!externalKey) return;
  
  apiGet(
  `/summary?externalKey=${encodeURIComponent(externalKey)}`
    )
    .then(json => {
      if (json.status !== "success") return;

      renderReviewSummary(json.data);
      renderFilterChips();
      syncFilterActiveStates();
      //bindSummaryFilterHandlers();
    })
    .catch(err => {
      console.error("Failed to load review summary", err);
    });
    }




  /**************************************************************
   * PRESIGN + UPLOAD (REVIEW MEDIA)
   **************************************************************/
    async function presignAndUploadReviewMedia(file) {

      const mimeType = file.type;

      const mediaType = mimeType.startsWith("image/")
        ? "image"
        : mimeType.startsWith("video/")
        ? "video"
        : "audio";
      //xx alert("mediaType" + mediaType);
      //xx alert("filename" + file.name);
      //xx alert("mimeType" + file.type);
      //xx alert("sizeBytes" + file.size);
      // 1️⃣ Ask backend for presigned URL
         const presignRes = await apiPost(
      "/media/presign",
      {
          files: [
           {
              mediaType,              // if backend uses this
              filename: file.name,    // 🔑 exact key name
              mimeType: file.type,    // string
              sizeBytes: file.size         // 🔑 number (bytes)
            }
          ]
        }
      );

      console.log("MEDIA PRESIGN RESPONSE (raw):", presignRes);

      if (!presignRes) {
        throw new Error("Presign failed: empty response");
      }

      if (presignRes.status !== "success") {
        throw new Error("Presign failed: " + JSON.stringify(presignRes));
      }

      const presigned = presignRes.data[0];   // 👈 index into array

      const { mediaUid, uploadUrl, s3Key } = presigned;

      console.log("UPLOAD URL:", uploadUrl);

      // 2️⃣ Upload directly to S3
      /*      const uploadRes = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type
        },
        body: file
      }); 
      if (!uploadRes.ok) {
        const text = await uploadRes.text();
        console.error("S3 upload failed", uploadRes.status, text);
        throw new Error("S3 upload failed");
      }*/

        // 2️⃣ Upload directly to S3 WITH PROGRESS
        const controller = new AbortController();
        activeUploads.set(mediaUid, controller);

        // Create preview early so progress bar can attach
        const previewUrl = URL.createObjectURL(file);

        uploadedReviewMedia.push({
          mediaUid,
          mediaType,
          s3Key,
          position: uploadedReviewMedia.length,
          previewUrl,
          uploaded: false        // ✅ important
        });

        // Render preview immediately (shows progress bar)
        renderReviewMediaPreview();
        updateSubmitState(); // 🔒 disable submit immediatel

        await new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open("PUT", uploadUrl, true);
          xhr.setRequestHeader("Content-Type", file.type);

          xhr.upload.onprogress = (e) => {
            if (!e.lengthComputable) return;
            const percent = Math.round((e.loaded / e.total) * 100);

            const media = uploadedReviewMedia.find(m => m.mediaUid === mediaUid);
            if (media?._progressBar) {
              media._progressBar.style.width = percent + "%";
            }
          };

          xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
              resolve();
            } else {
              reject(new Error("S3 upload failed"));
            }
          };

          xhr.onerror = () => reject(new Error("Upload error"));
          xhr.onabort = () => reject(new Error("Upload aborted"));

          controller.signal.addEventListener("abort", () => xhr.abort());
          xhr.send(file);
        });

        const media = uploadedReviewMedia.find(m => m.mediaUid === mediaUid);
        if (media) {
          media.uploaded = true;
          media._progressWrapper?.remove(); // hide progress bar
        }

        activeUploads.delete(mediaUid);

      // Update Media counter
      updateMediaCounter();
      updateSubmitState(); // ✅ re-enable if all done


      /* 3️⃣ Track uploaded media
      uploadedReviewMedia.push({
        mediaUid,
        mediaType,
        s3Key,         
        position: uploadedReviewMedia.length,
        previewUrl        // ✅ REQUIRED
      }); */

      
    }

    /*************************************
     * Can Add Files
     *************************************/
    function canAddFile(file, currentMedia) {

      const type =
        file.type.startsWith("image/") ? "image" :
        file.type.startsWith("video/") ? "video" :
        file.type.startsWith("audio/") ? "audio" : null;

      if (!type) return "Unsupported file type";

      if (currentMedia.length >= MEDIA_LIMITS.total)
        return `Maximum ${MEDIA_LIMITS.total} files allowed`;

      const countByType =
        currentMedia.filter(m => m.mediaType === type).length;

      if (countByType >= MEDIA_LIMITS[type].max)
       return `Only ${MEDIA_LIMITS[type].max} ${type} allowed`;

      if (file.size > MEDIA_LIMITS[type].maxSize)
        return `${type} file too large`;

      return null; // ✅ OK
    }

    /*************************************
     * Cleanup helper (important)
     ************************************/
    function cleanupCaptureUI() {
      const captureBox = document.getElementById("interaction-capture-preview");
      const videoEl = document.getElementById("live-video-preview");

      captureBox.style.display = "none";
      videoEl.srcObject = null;

      activeStream?.getTracks().forEach(t => t.stop());
      activeStream = null;
      activeRecorder = null;
      recordedChunks = [];
      captureState = "idle";   // 🔑 REQUIRED
    }


    /**************************************************************
     * MEDIA PREVIEW (REVIEW)
     **************************************************************/
   function renderReviewMediaPreview() {
      if (!reviewMediaPreview) return;

      reviewMediaPreview.innerHTML = ""; // 🔑 prevents duplicates

      uploadedReviewMedia.forEach((media, index) => {
        const wrapper = document.createElement("div");
        wrapper.className = "interaction-media-preview-item";

        let el;
        if (media.mediaType === "image") {
          el = document.createElement("img");
          el.src = media.previewUrl;
        }
        else if (media.mediaType === "video") {
          el = document.createElement("video");
          el.src = media.previewUrl;
          el.controls = true;
        }
        else {
          el = document.createElement("audio");
          el.src = media.previewUrl;
          el.controls = true;
        }

        el.className = "interaction-media-item";

        // ✅ Progress bar container (only show if not uploaded yet)
        const progress = document.createElement("div");
        progress.className = "interaction-media-progress";

        const bar = document.createElement("div");
        bar.className = "interaction-media-progress-bar";
        progress.appendChild(bar);

        // store refs on media so upload code can update width
        media._progressBar = bar;
        media._progressWrapper = progress;

        // ❌ Remove button
        const removeBtn = document.createElement("button");
        removeBtn.className = "interaction-media-remove";
        removeBtn.textContent = "✕";

        removeBtn.addEventListener("click", () => {
          removeReviewMedia(index);
        });

        wrapper.appendChild(el);
        wrapper.appendChild(removeBtn);

        // ✅ Add progress bar only while upload is in progress
        if (!media.uploaded) {
          wrapper.appendChild(progress);
        }

        reviewMediaPreview.appendChild(wrapper);
      });
    }


    /*********************************
     * Add the remove handler
     *********************************/
   function removeReviewMedia(index) {
      const removed = uploadedReviewMedia.splice(index, 1)[0];

      // 🛑 Abort in-flight upload (if any)
      const controller = activeUploads.get(removed.mediaUid);
      if (controller) {
        controller.abort();
        activeUploads.delete(removed.mediaUid);
      }

      // ♻️ Recalculate positions
      uploadedReviewMedia.forEach((m, i) => {
        m.position = i;
      });

      // 🧹 Free browser memory
      if (removed?.previewUrl) {
        URL.revokeObjectURL(removed.previewUrl);
      }

      // 🔁 Re-render preview
      renderReviewMediaPreview();

      // 🔢 Update counter
      updateMediaCounter();
    }





  
  /**********************************
   * Add a function to load replies
   ********************************/
  function loadReplies(parentUid) {
  const container = document.getElementById(`replies-${parentUid}`);
  if (!container) return;

  apiGet(`/replies?parentInteractionUid=${parentUid}`)
    .then(json => {
      if (json.status !== "success") return;

      // Clear existing rendered replies (keep the form)
      const existingReplies = container.querySelectorAll(".interaction-card.reply");
      existingReplies.forEach(r => r.remove());

      json.data.forEach(reply => {
        container.appendChild(renderReplyCard(reply));
      });
    });
  }

  /***************************
   * Render Reply Card
   **************************/
  function renderReplyCard(reply) {
  // ✅ DEFINE IT HERE
  const interactionUid = reply.interactionUid;
  const isOwner = reply.isOwner === true;

    if (!interactionUid) {
      console.error("Reply missing interactionUid:", reply);
      return document.createElement("div");
    }

    const el = document.createElement("div");
    el.className = "interaction-card reply";

    const ageLabel = reply.createdAt ? timeAgo(reply.createdAt) : "";
    const dateLabel = reply.createdAt
    ? new Date(reply.createdAt).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric"
      })
    : "";
    const likeCount = reply.reactionCounts?.like ?? 0;
    const loveCount = reply.reactionCounts?.love ?? 0;

    const viewerLikes = reply.viewerReactions?.includes("like");
    const viewerLoves = reply.viewerReactions?.includes("love");

    el.innerHTML = `
      <div class="interaction-header">
        <span class="interaction-user">${reply.customerId || "Guest"}</span>
         <span class="interaction-meta">          
          ${dateLabel ? `· ${dateLabel}` : ""}
          ${ageLabel ? `(${ageLabel})` : ""}
        </span>
      </div>

      <div class="interaction-text">${reply.body}</div>

      <div class="interaction-reactions">
        <button
          class="reaction-btn ${viewerLikes ? "reacted" : ""}"
          data-id="${interactionUid}"
          data-reactioncode="like">
          👍 <span class="reaction-count">${likeCount}</span>
        </button>

        <button
          class="reaction-btn ${viewerLoves ? "reacted" : ""}"
          data-id="${interactionUid}"
          data-reactioncode="love">
          ❤️ <span class="reaction-count">${loveCount}</span>
        </button>

        <!-- RIGHT: moderation -->
        <div class="interaction-moderation">
         ${isOwner ? `
            <button
              class="interaction-moderation-btn delete"
              data-action="delete"
              data-id="${interactionUid}"
              'title="Delete"
              aria-label="Delete review">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M9 3h6l1 2h5v2H3V5h5l1-2zm1 6h2v9h-2V9zm4 0h2v9h-2V9zM6 9h2v9H6V9z"
                  fill="currentColor"
                />
              </svg> Delete
            </button>
          ` : ""}

          ${!isOwner ? `
            <button
              class="interaction-moderation-btn report"
              data-action="report"
              title="Report"
              aria-label="Report review"
              data-id="${interactionUid}">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M5 3v18H3V3h2zm3 0h10l-2 4 2 4H8v10H6V3h2z"
                  fill="currentColor"
                />
              </svg> Report
            </button>
          ` : ""}
        </div>
    `;

    return el;
  }

  document.addEventListener("click", (e) => {

      // MEDIA filters
      const mediaEl = e.target.closest(".filter-media");
      if (mediaEl) {
        const type = mediaEl.dataset.media;

        // verified filter has no data-media
        if (mediaEl.classList.contains("filter-verified")) {
          interactionFilters.verifiedOnly = !interactionFilters.verifiedOnly;
          applyFiltersAndReload();
          return;
        }

        if (!type) return;

        const key =
          "has" + type.charAt(0).toUpperCase() + type.slice(1);

        interactionFilters[key] = !interactionFilters[key];
        applyFiltersAndReload();
        return;
      }

      // RATING filter
      const ratingBar = e.target.closest(".rating-bar");
      if (ratingBar) {
        const rating = Number(ratingBar.dataset.rating);
        if (!rating) return;

        interactionFilters.rating =
          interactionFilters.rating === rating ? null : rating;

        applyFiltersAndReload();
        return;
      }
    });








});
